import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Inject } from "@angular/core";
import { FieldDataService } from "src/app/services/fieldData/field-data.service";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import * as _ from "lodash";

@Component({
  selector: "app-node-alarm",
  templateUrl: "./node-alarm.component.html",
  styleUrls: ["./node-alarm.component.scss"],
})
export class NodeAlarmComponent implements OnInit {
  @Input() uuid: string;
  componentMode: string;
  @Output()
  onClose: EventEmitter<boolean> = new EventEmitter();
  @Input() filterMode: string;
  @Input() nodeType: string;
  sub: any;
  dataGatewaysRaiz: any;
  // nodeAlarmsArray: Array<AlarmNodeModel>;
  nodeAlarmsArray: any;
  // Para la tabla de gateways raiz
  displayedColumns: string[];
  dataSource: MatTableDataSource<any>;
  eventsSubject: Subject<void> = new Subject<void>();

  @ViewChild("TableGatewayRaizPaginator", { static: true })
  paginator: MatPaginator;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fieldDataService: FieldDataService,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {
    this.componentMode = this.data.componentMode;
    this.uuid = this.data.uuid;
    this.nodeType = this.data.nodeType;
    this.getRootElementsAlarms();
  }

  closeModal() {
    this.onClose.emit(true);
  }

  getRootElementsAlarms() {
    this.checkComponentMode(this.data.componentMode, this.data.filterMode);
  }

  emitEventToInfoComponent(element) {
    this.eventsSubject.next(element);
  }

  checkComponentMode(componentMode: string, filterMode: string) {
    this.filterMode = this.data.filterMode;

    switch (filterMode) {
      case "alarmado":
        switch (componentMode) {
          case "source":
            this.displayedColumns = [
              "acciones",
              "gateway",
              "fecha_evento",
              "lastFecha",
              "estadoAlarmas",
            ];
            this.fieldDataService.getNodeAlarms(this.uuid).subscribe((data) => {
              console.log("data: ", data);
              this.nodeAlarmsArray = data.filter(
                (elem) =>
                  elem["__typename"] != "Dato" &&
                  elem.entradas.some((r) => r.alarmado) &&
                  !elem.entradas.some((r) => r.silenciado)
              );
              this.dataSource = new MatTableDataSource(this.nodeAlarmsArray);
              this.dataSource.paginator = this.paginator;
            });
            break;
          case "entrada":
            this.displayedColumns = [
              "acciones",
              "dispositivo",
              "tipoDato",
              "fecha_evento",
              "lastFecha",
              "lastValor",
              "unidad",
            ];
            this.fieldDataService.getNodeAlarms(this.uuid).subscribe((data) => {
              console.log("data: ", data);

              this.nodeAlarmsArray = data.filter(
                (elem) =>
                  elem["__typename"] == "Dato" &&
                  elem.alarmado &&
                  !elem.silenciado
              );
              this.dataSource = new MatTableDataSource(this.nodeAlarmsArray);
              this.dataSource.paginator = this.paginator;
            });
            break;
          case "dato":
            this.displayedColumns = [
              "acciones",
              "dispositivo",
              "tipoDato",
              "fecha_evento",
              "lastFecha",
              "lastValor",
            ];
            this.fieldDataService.getNodeAlarms(this.uuid).subscribe((data) => {
              this.nodeAlarmsArray = data.filter(
                (elem) =>
                  elem["__typename"] == "Dato" &&
                  elem.alarmado &&
                  !elem.silenciado
              );
              this.dataSource = new MatTableDataSource(this.nodeAlarmsArray);
              this.dataSource.paginator = this.paginator;
            });
            break;
        }

        break;

      case "silenciado":
        switch (componentMode) {
          case "source":
            this.displayedColumns = [
              "acciones",
              "gateway",
              "fecha_evento",
              "lastFecha",
              "estadoAlarmas",
            ];
            this.fieldDataService.getNodeAlarms(this.uuid).subscribe((data) => {
              this.nodeAlarmsArray = data.filter(
                (elem) =>
                  elem["__typename"] != "Dato" &&
                  elem.lastEntrada &&
                  elem.lastEntrada.dato.silenciado
              );
              this.dataSource = new MatTableDataSource(this.nodeAlarmsArray);
              this.dataSource.paginator = this.paginator;
            });
            break;
          case "entrada":
            this.displayedColumns = [
              "acciones",
              "dispositivo",
              "tipoDato",
              "fecha_evento",
              "lastFecha",
              "lastValor",
              "unidad",
            ];
            this.fieldDataService.getNodeAlarms(this.uuid).subscribe((data) => {
              this.nodeAlarmsArray = data.filter(
                (elem) => elem["__typename"] == "Dato" && elem.silenciado
              );
              this.dataSource = new MatTableDataSource(this.nodeAlarmsArray);
              this.dataSource.paginator = this.paginator;
            });
            break;
          case "dato":
            this.displayedColumns = [
              "acciones",
              "dispositivo",
              "tipoDato",
              "alarmado",
              "ack",
              "lastFecha",
              "lastValor",
            ];
            this.fieldDataService.getNodeAlarms(this.uuid).subscribe((data) => {
              this.nodeAlarmsArray = data.filter(
                (elem) => elem["__typename"] == "Dato" && elem.silenciado
              );
              this.dataSource = new MatTableDataSource(this.nodeAlarmsArray);
              this.dataSource.paginator = this.paginator;
            });
            break;
        }
        break;
    }
  }

  actOverNodeRowAlarms(mode: string, uuid: string, type: string) {
    switch (mode) {
      case "silenciar":
        switch (type) {
          case "source":
            this.fieldDataService.silenceSource(uuid).subscribe((data) => {
              //TODO: Revisar
              // if (data.data.silenceSource && !data.errors) {
              if (data.data.silenceSource) {
                this.toastrService.success(
                  "Todos los datos de la estructura han sido silenciados con éxito"
                );
              } else {
                this.toastrService.error(
                  "Error. No se han podido silenciar los datos de la estructura"
                );
              }
            });
            break;
          case "dato":
            this.fieldDataService.silenceDato(uuid).subscribe((data) => {
              //TODO: if (data.data.silenceDato && !data.errors) {
              if (data.data.silenceDato) {
                this.toastrService.success("Dato silenciado con éxito");
              } else {
                this.toastrService.error(
                  "Error. No se han podido silenciar el dato"
                );
              }
            });
            break;
        }
        break;

      case "rearmar":
        switch (type) {
          case "source":
            this.fieldDataService.rearmarSource(uuid).subscribe((data) => {
              //TODO: if (data.data.rearmarSource && !data.errors) {
              if (data.data.rearmarSource) {
                this.toastrService.success(
                  "Todos los datos de la estructura han sido rearmados con éxito"
                );
              } else {
                this.toastrService.error(
                  "Error. No se han podido rearmar los datos de la estructura"
                );
              }
            });
            break;
          case "dato":
            this.fieldDataService.rearmarDato(uuid).subscribe((data) => {
              //TODO: if (data.data.rearmarDato && !data.errors) {
              if (data.data.rearmarDato) {
                this.toastrService.success("Dato rearmado con éxito");
              } else {
                this.toastrService.error(
                  "Error. No se han podido rearmar el dato"
                );
              }
            });
            break;
        }
        break;
    }
  }

  actOverNodeGlobalAlarms(mode: string, uuid: string, type: string) {
    switch (mode) {
      case "silenciar":
        switch (type) {
          case "nodeLink":
            this.fieldDataService.silenceNodeLink(uuid).subscribe((data) => {
              //TODO:  if (data.data.silenceNodeLink && !data.errors) {
              if (data.data.silenceNodeLink) {
                this.toastrService.success(
                  "Todos los datos en la estructura de la tabla han sido silenciados con éxito"
                );
              } else {
                this.toastrService.error(
                  "Error. No se han podido silenciar los datos de la estructura"
                );
              }
            });
            break;
          case "source":
            this.fieldDataService.silenceSource(uuid).subscribe((data) => {
              //TODO: if (data.data.silenceSource && !data.errors) {
              if (data.data.silenceSource) {
                this.toastrService.success(
                  "Todas los datos de esta entrada han sido silenciado con éxito"
                );
              } else {
                this.toastrService.error(
                  "Error. No se han podido silenciar los datos de la entrada"
                );
              }
            });
            break;
        }
        break;

      case "rearmar":
        switch (type) {
          case "nodeLink":
            this.fieldDataService.rearmarNodeLink(uuid).subscribe((data) => {
              //TODO: if (data.data.rearmarNodeLink && !data.errors) {
              if (data.data.rearmarNodeLink) {
                this.toastrService.success(
                  "Todos los datos en la estructura de la tabla han sido rearmados con éxito"
                );
              } else {
                this.toastrService.error(
                  "Error. No se han podido rearmar los datos de la estructura"
                );
              }
            });
            break;
          case "source":
            this.fieldDataService.rearmarSource(uuid).subscribe((data) => {
              //TODO:  if (data.data.rearmarSource && !data.errors) {
              if (data.data.rearmarSource) {
                this.toastrService.success(
                  "Todas los datos de esta entrada han sido rearmados con éxito"
                );
              } else {
                this.toastrService.error(
                  "Error. No se han podido rearmar los datos de la entrada"
                );
              }
            });
            break;
        }
        break;
    }
  }
}
